const SpikeVsPlateauVisual = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
    {/* Spike */}
    <div className="rounded-lg border border-red-200/60 bg-red-50/50 p-5">
      <p className="text-[12px] font-semibold text-red-700 uppercase tracking-wide mb-3">Spike &mdash; Fragile</p>
      <div className="flex items-end justify-center gap-[3px] h-24 mb-3">
        {[12, 14, 10, 13, 11, 15, 72, 14, 11, 13, 10, 12, 14, 11].map((h, i) => (
          <div
            key={i}
            className={`w-4 rounded-t ${i === 6 ? 'bg-red-400' : 'bg-red-200/60'}`}
            style={{ height: `${h}%` }}
          />
        ))}
      </div>
      <p className="text-[12px] text-gray-500 leading-relaxed">
        Isolated peak. Performance collapses with any parameter variation.
      </p>
    </div>

    {/* Plateau */}
    <div className="rounded-lg border border-emerald-200/60 bg-emerald-50/50 p-5">
      <p className="text-[12px] font-semibold text-emerald-700 uppercase tracking-wide mb-3">Plateau &mdash; Robust</p>
      <div className="flex items-end justify-center gap-[3px] h-24 mb-3">
        {[12, 18, 32, 54, 62, 65, 68, 66, 64, 58, 38, 22, 14, 12].map((h, i) => (
          <div
            key={i}
            className={`w-4 rounded-t ${h >= 50 ? 'bg-emerald-400' : 'bg-emerald-200/60'}`}
            style={{ height: `${h}%` }}
          />
        ))}
      </div>
      <p className="text-[12px] text-gray-500 leading-relaxed">
        Contiguous stable region. Neighbouring parameters produce consistent results.
      </p>
    </div>
  </div>
);

export default SpikeVsPlateauVisual;
